// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"63":"327c9861","308":"6dbd3bb2"}[chunkId] + ".css";
};